import { decryptData, encryptData } from "config/config";
import { instance as axios, setMultiPartHeader } from "config/axiosInstance";
import { isLoggedIn } from "utils";

// ****************************************** dropdown ************************************************
export const getCoursedropdown = async (data) => {
  return decryptData(
    await axios.get(
      `/get-postal-active-courses?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
// ****************************************** List ************************************************
export const getMapPostalDocumentsList = async (data) => {
  return decryptData(
    await axios.get(
      `/get-postal-course-docs?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
// ****************************************** Add ************************************************
export const getAddMapPostalDocuments = async (data) => {
  return decryptData(
    await axios.post(`/create-document-for-postal-course`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const UpdateMapPostalDocuments = async (data) => {
  return decryptData(
    await axios.post(`/update-document-for-postal-course`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const DeleteMapPostalDocuments = async (data) => {
  return decryptData(
    await axios.post(`/delete-document-for-postal-course`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const DeletePermanentlyMapPostalDocuments = async (data) => {
  return decryptData(
    await axios.post(`/delete-permanently-document-for-postal-course`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getPostalCourseFiles = async (data) => {
  return decryptData(
    await axios.get(
      `/get-files-by-postal-course-document?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  )
}
export const uploadFileToFolderForPostalCourse = async (data) => {
  return decryptData(
    await axios.post(`/upload-file-for-postal-course`, data, setMultiPartHeader())
  );
};
export const deleteFileFromPostalCourseFolder = async (data) => {
  return decryptData(
    await axios.post(`/delete-file-for-postal-course`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
export const renameFileOrFolder = async (data) => {
  return decryptData(
    await axios.post(`/rename-file-for-postal-course`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getDeletedPostalCourseDocs = async (data) => {
  return decryptData(
    await axios.get(
      `/get-deleted-postal-course-docs?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};